export const MY_DESIGN_DETAIL_TYPE_TEXT: string = "100";
export const MY_DESIGN_DETAIL_TYPE_TEXTAREA: string = "200";
export const MY_DESIGN_DETAIL_TYPE_COLOR_RGBA: string = "900";
export const MY_DESIGN_DETAIL_TYPE_COLOR_HEX: string = "910";
export const MY_DESIGN_DETAIL_TYPE_IMAGE_UPLOAD: string = "001";
export const MY_DESIGN_DETAIL_TYPE_IMAGE_CROPPER: string = "002";

export function isMyDesignDetailInputs(type: string | undefined): boolean {
    return type === MY_DESIGN_DETAIL_TYPE_TEXT || type === MY_DESIGN_DETAIL_TYPE_TEXTAREA;
}
export function isMyDesignDetailText(type: string | undefined): boolean {
    return type === MY_DESIGN_DETAIL_TYPE_TEXT;
}
export function isMyDesignDetailTextArea(type: string | undefined): boolean {
    return type === MY_DESIGN_DETAIL_TYPE_TEXTAREA;
}
export function isMyDesignDetailColor(type: string | undefined): boolean {
    return type === MY_DESIGN_DETAIL_TYPE_COLOR_RGBA || type === MY_DESIGN_DETAIL_TYPE_COLOR_HEX;
}
export function isMyDesignDetailImageUpload(type: string | undefined): boolean {
    return type === MY_DESIGN_DETAIL_TYPE_IMAGE_UPLOAD;
}
export function isMyDesignDetailImageCropper(type: string | undefined): boolean {
    return type === MY_DESIGN_DETAIL_TYPE_IMAGE_CROPPER;
}
export function isMyDesignDetailImages(type: string | undefined): boolean {
    return isMyDesignDetailImageUpload(type) || isMyDesignDetailImageCropper(type);
}